import { HTTPAPI } from "../base";
import qs from 'qs';


const grabToken = () => {
    const uInfoTxt = localStorage.getItem("userInfo");    
    let uInfo = null;
    if(uInfoTxt) {
        uInfo = JSON.parse(uInfoTxt);
    }
    const token = uInfo != null ? uInfo.token : "";    
    return token;
}

const assets = {
    uploadAsset: (data, targetFolder, onUploadProgress) => {
        return HTTPAPI(grabToken())
        .post(
            "/assets/uploadasset?targetFolder=" + targetFolder
            ,data
            ,{
                headers: {
                  "Content-Type": "multipart/form-data"
                },
                onUploadProgress
            }
        );
    },     
    getAssetsFolderContents: (folderName, orderby, searchterm) => {
        return HTTPAPI(grabToken())
        .get("/assets/getAssetsFolderContents/?folderName=" + folderName + "&orderby=" + (orderby ? encodeURIComponent(orderby) : '') + "&searchterm=" + (searchterm ? encodeURIComponent(searchterm) : ''));
    },
    createFolder: (currentFolder, newFolder) => {
        return HTTPAPI(grabToken())
        .post("/assets/createFolder/?currentFolder=" + encodeURIComponent(currentFolder),
            {                
                newFolder
            }
        );
    },   
}

export default assets;
